import React, { Component, Fragment } from 'react';
import SideBarContent from '../SideBar/SideBarContent';
import BookingWidget from './BookingWidget';
import IntroWidget from './IntroWidget';
import PromoWidget from './PromoWidget';
import EarningWidget from './EarningWidget';
import Button from '../../artzu-ui/src/Button';
import Divider from '../../artzu-ui/src/Divider';
import Modal from '../../artzu-ui/src/Modal';
import MediaQuery from 'react-responsive';
import CalendarOfBookings from './CalendarOfBookings';
import { m } from '../../utils';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import NewDashboard from '../NewDashboard';
import { withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import ScrollLock from 'react-scrolllock';
import Hourglass from '../../images/Icons/pending-reactivation.svg';

const GQL_ROOT = `${process.env.REACT_APP_API_URL}/graphql`;
class NewDash extends Component {
  constructor(props) {
    super(props);
    const monthStart = m()
      .clone()
      .startOf('month');
    const monthEnd = monthStart.clone().endOf('month');
    const startDate = monthStart.clone().startOf('isoWeek');
    const endDate = monthEnd
      .clone()
      .endOf('isoWeek')
      .add(1, 'day');
    this.state = {
      display: 'index',
      format: 'calendar',
      currentMonth: m(),
      monthStart,
      monthEnd,
      calendarStart: startDate,
      calendarEnd: endDate,
      selectedBooking: null,
      shiftIndex: 0,
      showNegativeModal: false,
      showIntro: false,
      showIntroNyc: false,
      showConsentModal: !this.props.via_consent
    };
  }

  componentDidMount() {
    this.props.loadUser();
    this.props.loadData();

    this.setState({
      showNegativeModal: this.props.status === 'negative_balance',
      showConsentModal: !this.props.via_consent
    });
    const { operatingCity } = this.props;
    operatingCity === 'toronto'
      ? this.setState({ showIntro: true })
      : null;
    operatingCity === 'new_york'
      ? this.setState({ showIntroNyc: true })
      : null;
  }

  formatShift = shiftHour =>
    `${shiftHour % 12}${shiftHour / 12 < 1 ? 'am' : 'pm'}`;

  selectBooking = selectedBooking => {
    this.setState({ selectedBooking, shiftIndex: 0, display: 'details' });
  };

  handleShiftIndexChange = shiftIndex => {
    this.setState({ shiftIndex });
  };

  nextMonth = () => {
    const nextMonth = this.state.currentMonth.add(1, 'month');
    const monthStart = nextMonth.clone().startOf('month');
    const start = monthStart.clone().startOf('isoWeek');
    const monthEnd = nextMonth.clone().endOf('month');
    const finish = monthEnd
      .clone()
      .endOf('isoWeek')
      .add(1, 'day');
    this.setState({
      currentMonth: nextMonth,
      startDate: start,
      calendarStart: start,
      calendarEnd: finish,
      monthStart,
      monthEnd
    });
  };

  prevMonth = () => {
    const prevMonth = this.state.currentMonth.subtract(1, 'month');
    const monthStart = prevMonth.clone().startOf('month');
    const start = monthStart.clone().startOf('isoWeek');
    const monthEnd = prevMonth.clone().endOf('month');
    const finish = monthEnd
      .clone()
      .endOf('isoWeek')
      .add(1, 'day');
    this.setState({
      currentMonth: prevMonth,
      startDate: start,
      calendarStart: start,
      calendarEnd: finish,
      monthStart,
      monthEnd
    });
  };

  hideNegativeModal = () => {
    this.setState({ showNegativeModal: false });
  };

  negativeModal = () => (
    <Modal open={this.state.showNegativeModal}>
      <div className="unavailable-modal">
        <p>
          Your account has been suspended for carrying a negative balance.
          To regain access to our services, check your balance and pay the
          amount owed
        </p>
        <Button
          margin="1em 0 0 0"
          label="Later"
          color="#414141"
          onClick={this.hideNegativeModal}
        />
        <Button
          margin="1em 0 0 0"
          label="Pay Now"
          onClick={() => this.props.history.push('/myearnings')}
        />
      </div>
    </Modal>
  );

  viaConsentModal = () => (
    <Modal
      open={
        this.props.operatingCity === 'new_york' &&
        this.state.showConsentModal
      }>
      <div className="apply__uber--terms-modal">
        <div
          className="apply__uber--terms-modal-text"
          style={{ textAlign: 'left', fontSize: '11px' }}>
          {' '}
          By clicking “Accept” with no further action, you agree that the
          fees you owe to Autzu (including Booking Fees and additional fees
          as applicable) will be deducted from your Via Driver Partner
          earnings and paid directly to Autzu on your behalf (the Earnings
          Deduction). You may opt out of the Earnings Deduction by emailing
          info@autzu.com, in which case you will be required to pre-pay
          your Booking Fees and any additional applicable fees by credit
          card.
          <br />
          See Section 6 of the{' '}
          <a href="/terms#earnings" target="_blank">
            Autzu Terms & Conditions
          </a>{' '}
          for more information.{' '}
        </div>
        <div
          className="apply__uber--terms-modal-button"
          style={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-evenly'
          }}>
          <Button
            label="Contact Us"
            onClick={() => {
              let media = window.matchMedia('(max-width: 767px)');
              if (media.matches) {
                window.location.assign('tel:+18336928898');
              } else {
                window.location.assign('/contact');
              }
            }}
            color="#414141"
          />
          <Button label="Accept" onClick={() => this.viaConsent()} />
        </div>
      </div>
    </Modal>
  );

  viaConsent = () => {
    const mutationString = gql`
      mutation ViaDeductionConsent($consentTime: DateTime!) {
        viaDeductionConsent(consentTime: $consentTime) {
          consentReceived
        }
      }
    `;
    this.props.client
      .mutate({
        mutation: mutationString,
        variables: { consentTime: m() }
      })
      .then(res => {
        if (res.data.viaDeductionConsent.consentReceived === true) {
          this.setState({ showConsentModal: false });
          this.props.loadData();
        }
      });
  };

  REOPEN_ACCOUNT = gql`
    mutation reopenUser {
      reopenUser {
        user {
          fullName
          status
        }
        errors {
          message
        }
      }
    }
  `;

  CLOSE_ACCOUNT = gql`
    mutation closeUser {
      closeUser {
        user {
          fullName
          status
        }
        errors {
          message
        }
      }
    }
  `;

  toggleClose = () => {
    this.props.client
      .mutate({
        mutation:
          this.props.status === 'closed'
            ? this.REOPEN_ACCOUNT
            : this.CLOSE_ACCOUNT
      })
      .then(() => this.props.loadData());
  };

  toggleDeactivateModal = () =>
    this.setState({ deactivateAccount: !this.state.deactivateAccount });

  render() {
    const {
      shiftIndex,
      currentMonth,
      calendarStart,
      calendarEnd,
      showIntro,
      showIntroNyc
    } = this.state;
    const { status, loggedIn, history, operatingCity } = this.props;
    if (status === 'lead' || status === 'subscribed') {
      return <Redirect to="/apply" />;
    }
    if (
      ![
        'operating',
        'negative_balance',
        'closed',
        'blacklisted',
        'pending_reactivation',
        'weekly_lease'
      ].includes(status)
    )
      return <NewDashboard {...this.props} />;

    return (
      <Fragment>
        <div className="dash-index container dash__full-height">
          {this.viaConsentModal()}
          {this.negativeModal()}
          <Modal open={this.state.deactivateAccount}>
            <div className="profile__deactivate-account">
              {' '}
              <div className="profile__deactivate-account--text">
                {' '}
                {status === 'closed'
                  ? 'Your request will be processed in 1-2 business days. We will contact you about next steps.'
                  : operatingCity === 'toronto'
                  ? 'Deactivating your Autzu account will prevent you from being able to book vehicles. If you are an operating driver, we will have your Uber account removed from the Autzu fleet within 1 business day. You can reactivate your account at any time!'
                  : 'Deactivating your Autzu account will prevent you from being able to book vehicles. You can reactivate your account at any time!'}{' '}
              </div>
              <div className="profile__deactivate-account--actions">
                <Button
                  className="profile__deactivate-account--button"
                  label="Cancel"
                  onClick={() => this.toggleDeactivateModal()}
                  color="#414141"
                />{' '}
                <Button
                  className="profile__deactivate-account--button"
                  label={status === 'closed' ? 'Reactivate' : 'Deactivate'}
                  onClick={() => {
                    this.toggleClose();
                    this.toggleDeactivateModal();
                  }}
                />
              </div>
            </div>
          </Modal>
          <div className="desktop-subheader">
            Dashboard
            {status === 'operating' ? (
              <Button
                label="Book"
                className="dash-book-button"
                padding="0"
                margin="0"
                primary
                onClick={() => history.push('/book')}
              />
            ) : null}
            {status === 'negative_balance' ? (
              <Button
                label="View Balance"
                className="dash-pay-button"
                padding="0"
                margin="0"
                color="#ff0000"
                primary
                onClick={() => history.push('/myearnings')}
              />
            ) : null}
          </div>
          <MediaQuery minWidth={767}>
            {showIntro && status === 'operating' ? (
              <IntroWidget mobile={false} />
            ) : null}
            {showIntroNyc && status === 'operating' ? (
              <IntroWidget mobile={false} city={operatingCity} />
            ) : null}
          </MediaQuery>
          <div className="sidebar-container">
            <SideBarContent status={status} signedIn={loggedIn} />
          </div>
          <ScrollLock>
            {status === 'closed' ||
            status === 'blacklisted' ||
            status === 'pending_reactivation' ? (
              <Fragment>
                <div className="dashboard__border dashboard__border--left" />
                <div className="dashboard__container--closed--container">
                  <div className="dashboard__container--closed">
                    {' '}
                    {status === 'pending_reactivation' ? (
                      <img
                        className="dashboard__container--image"
                        src={Hourglass}
                      />
                    ) : null}
                    <div className="dashboard__container--closed-text">
                      {' '}
                      {(() => {
                        switch (status) {
                          case 'closed':
                            return 'Your account has been closed. Please request account reactivation.';
                          case 'blacklisted':
                            return 'You account has been suspended';
                          case 'pending_reactivation':
                            return 'Thank you for requesting to reactivate your account. Please wait 1-2 business days for us to verify your documents. We will contact you shortly.';
                          default:
                            return '';
                        }
                      })()}
                    </div>
                    {status === 'closed' ? (
                      <Button
                        primary={status !== 'pending_reactivation'}
                        color={
                          status === 'pending_reactivation'
                            ? '#414141'
                            : '#128DFF'
                        }
                        label={
                          status === 'pending_reactivation'
                            ? 'Cancel Reactivation Request'
                            : 'Request Reactivation'
                        }
                        onClick={this.toggleDeactivateModal}
                        className="dashboard__container--closed-button"
                      />
                    ) : null}
                  </div>
                </div>
              </Fragment>
            ) : (
              <Fragment>
                <MediaQuery minWidth={768}>
                  <div className="calendar-container">
                    <div className="book-top">
                      <p>Bookings</p>
                      {status === 'weekly_lease' ? null : (
                        <Link to="/mybookings">See All</Link>
                      )}
                    </div>
                    <CalendarOfBookings
                      currentMonth={currentMonth}
                      calendarStart={calendarStart}
                      calendarEnd={calendarEnd}
                      nextMonth={this.nextMonth}
                      prevMonth={this.prevMonth}
                      formatShift={this.formatShift}
                      selectBooking={this.selectBooking}
                      shiftIndex={shiftIndex}
                      handleShiftIndexChange={this.handleShiftIndexChange}
                      dashboardParent
                      status={status}
                    />
                  </div>
                  <div className="promo-earning-container">
                    <PromoWidget status={status} />
                    {status === 'weekly_lease' ? null : (
                      <Divider margin="0 1em" />
                    )}
                    <EarningWidget status={status} />
                  </div>
                </MediaQuery>
                <ScrollLock>
                  <div className="dash__scroll--mob">
                    <MediaQuery maxWidth={767}>
                      {showIntro && status === 'operating' ? (
                        <IntroWidget mobile={true} />
                      ) : null}
                      {showIntroNyc && status === 'operating' ? (
                        <IntroWidget mobile={true} city={operatingCity} />
                      ) : null}
                      <BookingWidget
                        formatShift={this.formatShift}
                        status={status}
                      />
                      <div className="promo-earning-container">
                        <PromoWidget status={status} />
                        {status === 'weekly_lease' ? null : (
                          <Divider margin="0 1em" />
                        )}
                        <EarningWidget status={status} />
                      </div>
                    </MediaQuery>
                  </div>
                </ScrollLock>
              </Fragment>
            )}
          </ScrollLock>
        </div>
      </Fragment>
    );
  }
}

export default withApollo(NewDash);



// WEBPACK FOOTER //
// ./src/components/NewDash/index.js